import { MapViewerNode } from '@3ddv/dvm-internal';
import { ApplicationRef, createComponent, EnvironmentInjector, Injectable } from '@angular/core';
import { computePosition, shift, flip, offset, VirtualElement } from "@floating-ui/dom";
import { PopoverComponent } from '../components/viewport/popover/popover.component';

@Injectable({
  providedIn: 'root'
})
export class PopoverService {
  private popoverInstances: Map<string, HTMLElement> = new Map();
  private popoverTimeout: {timeout: any, node: MapViewerNode | null} = {timeout: null, node: null};

  constructor(
    private environment: EnvironmentInjector,
    private appRef: ApplicationRef,
    // private document: Document
  ) { }

  public showPopover(node: MapViewerNode) {
    this.createPopover(node);

    // // Clear any existing timeout to prevent the previous logic from executing
    // if (this.popoverTimeout && this.popoverTimeout.timeout && this.popoverTimeout.node) {
    //   clearTimeout(this.popoverTimeout.timeout);
    //   this.destroyPopover(this.popoverTimeout.node);
    // }

    // // Set a new timeout for the current node
    // this.popoverTimeout.node = node;
    // this.popoverTimeout.timeout = setTimeout(() => {
    //   this.createPopover(node);
    // }, 100);
  }

  public hidePopover(node: MapViewerNode) {
    this.destroyPopover(node);
  }

  // CREATE POPOVER
  private createPopover(node: MapViewerNode) {

    // Create a new popover host element
    const popoverHost = document.createElement('div');
    popoverHost.classList.add('popover');
    document.body.appendChild(popoverHost);

    // Create the popover component instance
    const popoverComponent = createComponent(PopoverComponent, {
      environmentInjector: this.environment,
      hostElement: popoverHost
    });
    // Set the component inputs
    popoverComponent.setInput('node', node);
    // Detect changes to update the view
    popoverComponent.changeDetectorRef.detectChanges();
    // Attach the component to the application
    this.appRef.attachView(popoverComponent.hostView);

    // Compute the position of the popover (using Floating UI)
    computePosition(node as MapViewerNode | VirtualElement, popoverHost, {
      placement: "bottom",
      middleware: [offset(16), flip(), shift()],
      strategy: 'absolute'
    }).then(({ x, y }) => {
      Object.assign(popoverHost.style, {
        position: 'absolute',
        top: `${y}px`,
        left: `${x}px`
      });
    });

    // Set and store the component host on popoverInstances Map
    this.popoverInstances.set(node.id, popoverHost);

  }

  // DESTROY POPOVER
  private destroyPopover(node: MapViewerNode) {

    const popoverHost = this.popoverInstances.get(node.id)!;
    
    if (popoverHost) {
      // Detach the component from the application
      popoverHost.parentNode?.removeChild(popoverHost);

      // Delete the component instance from the Map
      this.popoverInstances.delete(node.id);
    }
    
  }

}
